module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp1-05-a68195f7b38ca5ded09bba5d5705c919.png";